import Layout from '@/components/feature/Layout';
import SEOMeta from '@/components/base/SEOMeta';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import NewsletterSection from './components/NewsletterSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '凤楼信息',
  url: 'https://www.fenglou-info.com',
  description: '凤楼信息为您提供最全面、最及时的凤楼信息服务，涵盖本地生活、商务资讯、休闲娱乐等多维度内容，助您快速获取所需凤楼信息，省时高效，一站直达。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.fenglou-info.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <Layout>
      <SEOMeta
        title="凤楼信息 - 最新资讯与信息服务平台"
        description="凤楼信息为您提供最全面、最及时的凤楼信息服务，涵盖本地生活、商务资讯、休闲娱乐等多维度内容，助您快速获取所需凤楼信息，省时高效，一站直达。"
        keywords="凤楼信息,凤楼信息查询,凤楼最新信息,凤楼信息平台,凤楼资讯,本地凤楼信息,凤楼信息大全"
        canonicalUrl="https://www.fenglou-info.com"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20Chinese%20information%20service%20platform%20branding%2C%20clean%20professional%20design%2C%20warm%20tones%2C%20city%20silhouette%2C%20elegant%20typography%2C%20information%20concept&width=1200&height=630&seq=og-home-fenglou&orientation=landscape"
        schema={homeSchema}
      />

      <article>
        <h1 className="sr-only">凤楼信息 - 最新资讯与信息服务平台</h1>
        <HeroSection />
        <FeaturedArticles />
        <CategoryNav />
        <LatestArticles />
        <NewsletterSection />
      </article>
    </Layout>
  );
}